import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate, matchRoutes } from 'react-router-dom';
import { connect } from 'react-redux';
import FuseUtils from '@fuse/utils';
import AppContext from 'app/AppContext';
import jwtService from 'app/services/jwtService';

const FuseAuthorization = ({ children, userRole, userGroup }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { routes } = useContext(AppContext);
  const [accessGranted, setAccessGranted] = useState(true);

  useEffect(() => {
    const { pathname } = location;

    // Recherche la route ou l'url est le même
    const matched = matchRoutes(routes, pathname)?.[0]; // Find matched route

    // Vérifie si il a les droits
    const granted = matched
      ? FuseUtils.hasPermission(matched.route.auth, userRole) &&
        FuseUtils.hasGroupPermission(matched.route.group, userGroup) &&
        (!matched.route.display ||
          FuseUtils.hasDisplayType(matched.route.display))
      : true;

    setAccessGranted(granted);

    // Check if token is valid if not, redirect to login
    const access_token = window.localStorage.getItem('jwt_access_token');
    jwtService.isAuthTokenValid(access_token);

    if (!granted) {
      redirectRoute();
    }
  }, [location, userRole, userGroup, routes]);

  const redirectRoute = () => {
    const { state } = location;
    const redirectUrl = state && state.redirectUrl ? state.redirectUrl : '/';

    if (!userRole || userRole.length === 0) {
      navigate('/login', { state: { redirectUrl: '/' } });
    } else {
      navigate(redirectUrl);
    }
  };

  return accessGranted ? children : null;
};

const mapStateToProps = ({ auth }) => ({
  userRole: auth.user.role,
  userGroup: auth.user.group
});

export default connect(mapStateToProps)(FuseAuthorization);
